import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';
import { Divider } from '@hivebrite/design-system/Divider';

import AddToCalendar from 'hb-react/frontoffice/components/AddToCalendar';
import EventShare from 'hb-react/shared/apps/Events/components/EventShare';
import { type Event } from 'hb-react/shared/apps/Events/types';
import SuccessCircleCheck from 'hb-react/shared/icons/SuccessCircleCheck';

export const CustomSuccessMessage = ({ successPageContent }) => (
  <Box
    display="block"
    className="ckeditor-content--reset"
    data-testid="success-page-content"
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{ __html: successPageContent }}
  />
);

const GenericSuccessMessage = ({ headline, tagline }) => (
  <>
    <Box>
      <Box color="grass">
        <SuccessCircleCheck title={__('Success')} width="30px" height="30px" />
      </Box>
      <Box font="h3-semibold" pl="4" pt="1">
        {headline || __('Thank you for registering for this event')}
      </Box>
    </Box>
    <Divider borderBottomWidth="1.5px" borderBottomColor="#cdcdcd" mt={3} />
    <Box>{tagline || __('We hope to see you there')}</Box>
  </>
);

// Used in BO for the preview
export const SuccessMessagePreview = ({
  successPageContent,
  headline,
  tagline,
}: {
  headline?: string;
  successPageContent: string;
  tagline?: string;
}) =>
  successPageContent ? (
    <CustomSuccessMessage successPageContent={successPageContent} />
  ) : (
    <GenericSuccessMessage headline={headline} tagline={tagline} />
  );

interface SuccessMessageProps {
  calendarAccessToken?: string;
  eventType: string;
  headline?: string;
  id: number;
  selectedMediaIcons: Event['social_media_list'];
  sharingParameters: {
    title: string;
    url: string;
  };
  successPageContent: any;
  tagline?: string;
  timezone: string;
}

const SuccessMessage = ({
  headline,
  tagline,
  successPageContent,
  sharingParameters,
  selectedMediaIcons = [],
  id,
  timezone,
  eventType,
  calendarAccessToken,
}: SuccessMessageProps) => (
  <Card pt={5}>
    <SuccessMessagePreview
      successPageContent={successPageContent}
      headline={headline}
      tagline={tagline}
    />
    <Box pt={5} flexDirection="column">
      <Box mb={5}>
        <AddToCalendar
          id={id}
          timezone={timezone}
          eventType={eventType}
          calendarAccessToken={calendarAccessToken}
        />
      </Box>
      {selectedMediaIcons.length > 0 && (
        <EventShare
          selected={selectedMediaIcons}
          url={sharingParameters.url}
          title={sharingParameters.title}
        />
      )}
    </Box>
  </Card>
);

export default SuccessMessage;
